// @flow
import createReducer from '../utils/createReducer';
import { API_CALL_SUCCESS, API_CALL_FAILURE, API_CALL_REQUEST } from '../constants/actionTypes';
import { COMPETITIONS_LIST, ULTIMATE_CHALLENGE, USER_SIGN_OUT } from '../constants/apiTypes';
import decodeUltimateChallenge from '../normalizers/decodeUltimateChallenge';
import decodeCompetition from '../normalizers/decodeCompetition';

const initialState = {
  competitionsList: [],
  currentUserEntry: null,
  entered: false,
  entries: [],
  errors: null,
  errorStatus: null,
  hasInitialised: false,
  id: null,
  isLoading: true,
  leaderboardId: null,
  name: '',
  startTime: null,
  updatedTime: null
};

const ultimateChallengeReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, { api }) => {
    if (api === ULTIMATE_CHALLENGE) {
      return {
        isLoading: true,
        errors: null,
        errorStatus: null
      };
    }
    return {};
  },
  [API_CALL_SUCCESS]: (state, { data, api }) => {
    switch (api) {
      case ULTIMATE_CHALLENGE:
        return data
          ? {
              ...decodeUltimateChallenge(data),
              hasInitialised: true,
              isLoading: false
            }
          : {};
      case USER_SIGN_OUT:
        return {
          currentUserEntry: null,
          entered: false
        };
      case COMPETITIONS_LIST:
        return {
          competitionsList: data.map(decodeCompetition)
        };
      default:
        return {};
    }
  },
  [API_CALL_FAILURE]: (state, { errors, api, status }) => {
    if (api === ULTIMATE_CHALLENGE) {
      return {
        isLoading: false,
        errors,
        errorStatus: status
      };
    }
    return {};
  }
});

export default ultimateChallengeReducer;
